import { FormikErrors, FormikTouched } from "formik";
import * as Yup from "yup";

export interface AudioProps {
  handleBlur: React.FocusEventHandler<HTMLInputElement>;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  touched: FormikTouched<{
    artist: string;
    title: string;
    description: string;
    songUpload: undefined;
    coverArtUpload: undefined;
    skills: never[];
    genres: string[];
    newCollab: {
      username: string;
      share: string;
    };
  }>;
  errors: FormikErrors<{
    artist: string;
    title: string;
    description: string;
    songUpload: undefined;
    coverArtUpload: undefined;
    skills: never[];
    genres: string[];
    newCollab: {
      username: string;
      share: string;
    };
  }>;
  isSubmitting: boolean;
  transferClearAudio: (clearAction: any) => void;
  dawExportedBlob?: Blob;
  songTitle?: string;
  songUrl?: string;
  handleSongChanged?: () => void;
  determineBpm?: (
    file: File,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined
    ) => void,
    setBpmLoading: (value: React.SetStateAction<boolean>) => void
  ) => void;
  setBpmLoading?: (value: React.SetStateAction<boolean>) => void;
}

export interface Collaborator {
  username: string;
  share: string;
  id?: string;
}

export interface MintDTO {
  user_id: string;
  artist: string;
  title: string;
  price: number;
  bpm: number;
  description: string;
  coverArtUrl: string;
  songUrl: string;
  genres: Array<string>;
  collaborators: Array<Collaborator>;
  owner: {
    address: string;
    share: number;
  };
  key: Array<string>;
  trackId: string;
}

export const presets = [
  "a: Tight dynamics and ample brightness in the upper frequencies [Pop]",
  "b: Tight dynamics, a solid low-end, and mid-frequency clarity for vocal emphasis [Club, EDM]",
  "c: Big bass presence and tight dynamics [Hip Hop]",
  "d: Heavy bass and sub-bass presence [Hip Hop]",
  "e: Big bass and sub-bass presence with additional openness in the mid and high frequencies [Hip Hop, Trap]",
  "f: Wide low-end processing with a light and ethereal tone [Lighter Electronic, EDM]",
  "g:	Wide low-end processing with dark and moody tone [Darker Electronic, EDM]",
  "h:	Wide dynamics and ample openness in the mids and highs to allow for a wide spectrum of sound [Electronic, EDM]",
  "i:	Tight dynamics, and a well rounded, balanced tone [Pop, Rock, Country]",
  "j: Smooth, tight dynamics, and a light lift in the upper frequencies [Rock, Country]",
  "k:	Wide dynamics with a solid low and mid-frequency boost [Pop]",
  "l:	Emphasis on the mid-frequencies to highlight vocals [Vocal]",
  "m:	Light touch with ample mid-frequency clarity to let acoustic instruments shine in the mix [Folk, Acoustic]",
  "n:	Wide dynamics, and warm full tones for orchestral instruments [Classical]",
];

export const NFT_VALIDATION_SCHEMA = Yup.object().shape({
  artist: Yup.string().max(120, "Too Long!").required("the artist is Required"),
  title: Yup.string()
    .max(120, "Too Long!")
    .required("the song title is Required"),
  price: Yup.number().min(0.01, "Amount must be greater than 0.01"),
  bpm: Yup.number()
    .min(0, "Amount must be greater than 0")
    .max(200, "Amount must be less than 200"),
  description: Yup.string().required("the description is Required"),
  songUpload: Yup.mixed().required("required"),
  coverArtUpload: Yup.mixed().required("required"),
  genres: Yup.string().required("Genre is required"),
});
